import { atom } from 'jotai';

export const BackgroundViewAtom = atom<{
	isLoading?: boolean;
	title?: string;
}>({ isLoading: false });
